import * as React from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { Select } from '@ixicare/ui';
import { t } from '~/i18n';
import { useStores } from '~store/utils';
import { useSelectedSite } from '~hooks/useSelectedSite';
import { getSiteSelectorMode } from '~config/siteSelectorRoutes';

const SiteSelector: React.FC = observer(() => {
  const { sites } = useStores();
  const [selectedSite, setSelectedSiteUuid] = useSelectedSite();
  const location = useLocation();

  const mode = getSiteSelectorMode(location.pathname);
  if (mode === 'hidden') return null;
  if (!sites.loaded || sites.sites.length === 0) return null;

  const options = sites.sites.map((s) => ({ value: s.uuid, label: s.name }));
  const enabled = mode === 'enabled';

  return (
    <>
      <label style={{ whiteSpace: 'nowrap', marginBottom: 0 }}>{t('devices.table.selectSite') + ':'}</label>
      <div style={{ minWidth: 300, opacity: enabled ? 1 : 0.5, pointerEvents: enabled ? 'auto' : 'none' }}>
        <Select
          value={selectedSite?.uuid ?? null}
          onChange={(uuid: string) => setSelectedSiteUuid(uuid)}
          options={options}
          placeholder={t('devices.table.selectSite')}
          as="filter"
        />
      </div>
    </>
  );
});

export default SiteSelector;
